// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getProp from "@insite/mobius/utilities/getProp";
import { floatingTooltipStyles } from "@keller/App/Components/FloatingTooltip/FloatingTooltip";
import color, { getSystemColor } from "@keller/XDL/Utilities/color";
import { styledScrollbar } from "@keller/XDL/Utilities/scroll";
import xScreen from "@keller/XDL/Utilities/xScreen";
import { css } from "styled-components";

floatingTooltipStyles.tooltipContent = {
    css: css`
        color: ${color("text.main")};
        z-index: ${getProp("theme.zIndex.floatingUi")};
        background-color: ${color("common.white")};
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        box-shadow: ${getProp("theme.shadows.4")};
        min-width: 200px;
        &:focus,
        & > *:focus {
            outline: none;
        }

        ${xScreen("lte", "sm")} {
            padding: 20px 14px;
            border-radius: 0;
        }
    `,
};

floatingTooltipStyles.drawerClose = {
    size: 14,
    icon: {
        src: "X",
        position: "left",
    },
    color: "common.ui5",
    css: css`
        cursor: pointer;
        position: absolute;
        right: 10px;
        top: 10px;
        z-index: 999;
        &:hover {
            color: ${color("danger")};
        }
    `,
};

floatingTooltipStyles.tooltipArrow = {
    width: 16,
    height: 8,
    fill: getSystemColor("common.white"),
    stroke: `${getSystemColor("common.border")}`,
    strokeWidth: 1,
};

floatingTooltipStyles.tooltipInnerContent = {
    css: css`
        ${styledScrollbar(2)}
    `,
};
